import { render, staticRenderFns } from "./InspectionCenter.vue?vue&type=template&id=40a8c997&scoped=true"
import script from "./InspectionCenter.vue?vue&type=script&lang=js"
export * from "./InspectionCenter.vue?vue&type=script&lang=js"
import style0 from "./InspectionCenter.vue?vue&type=style&index=0&id=40a8c997&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a8c997",
  null
  
)

export default component.exports